export const Delete = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 15 14" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33"
        d="M1.5 3.399h1.333m0 0H13.5m-10.667 0v8.4c0 .318.14.623.39.849.25.225.59.351.944.351h6.666c.354 0 .693-.126.943-.351.25-.226.39-.53.39-.849v-8.4H2.834Zm2 0v-1.2c0-.318.14-.623.39-.849.25-.225.59-.351.944-.351h2.666c.354 0 .693.126.943.351.25.226.39.53.39.849v1.2m-4 3v3.6m2.667-3.6v3.6"
      />
    </svg>
  );
};
